import script from "./ValidacaoFalhou.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidacaoFalhou.vue?vue&type=script&setup=true&lang=js"

import "./ValidacaoFalhou.vue?vue&type=style&index=0&id=f1f80386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f80386"]])

export default __exports__